import React from 'react';
import ChatContainer from '../../common/ChatContainer/ChatContainer';

export default () => <ChatContainer mode="driver-chat" />;
